import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { UserTypesRelationshipService } from 'src/app/services/user-types-relationship.service';
import { TranscriptionCreateService } from '../../transcription-create/transcription-create.service';
import { BillerDashboardService } from '../biller-dashboard.service';
import { ChargesPopupComponent } from '../charges-popUp/charges-popup/charges-popup.component';
import * as global from '../../global';
import { CommonService } from 'src/app/services/common.service';
import { I } from '@angular/cdk/keycodes';
import { HttpResponse } from '@angular/common/http';
import { PatientDocumentService } from '../../patient-documents-list/patient-document-list.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { API_URL } from '../../../../environments/api-url'
import { PdfViewerPopComponent } from '../../patient-documents-list/pdf-viewer-pop/pdf-viewer-pop.component';
import { FaceSheetService } from '../../patient-detail/facesheet/face-sheet.service';
import { PatientDocumentsUploadDialog } from '../../patient-documents-list/patient-documents-upload-dialog/patient-documents-upload-dialog.component';
import { DialogConfirmationComponent } from '../../census-patient-list/dialog-confirmation/dialog-confirmation.component';
import { FileExplorerService } from '../../drive/file-explorer/file-explorer.service';
import swal from 'sweetalert';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { AuditPopupComponent } from '../audit-popup/audit-popup/audit-popup.component';
import { ChargeCommentDialogComponent } from '../charge-comment-dialog/charge-comment-dialog.component';
import _ from 'lodash';
import ExcelJS from 'exceljs';
import { flatten } from 'flat';
import { PatientRoundingSheetService } from '../../patient-rounding-sheets/patient-rounding-sheet.service';
import { MatCheckbox } from '@angular/material/checkbox';

interface IFilter {
  active: boolean,
  creation_date: {
    startDate: any | Date | moment.Moment,
    endDate: any | Date | moment.Moment
  },
  date_of_service: {
    startDate: any | Date | moment.Moment,
    endDate: any | Date | moment.Moment
  },
  user: string,
  facility: string,
  patient: string,
  progress_status: string
}
interface BReport {
  dos: string,
  provider: any[]
}
@Component({
  selector: 'app-admin-charge-capture',
  templateUrl: './admin-charge-capture.component.html',
  styleUrls: ['./admin-charge-capture.component.css']
})
export class AdminChargeCaptureComponent implements OnInit {
  filteredFacilities: Observable<string[]>;
  facilityControl = new FormControl();
  filteredProvider: Observable<string[]>;
  providerControl = new FormControl();
  global = global;

  public isVisibleTable: boolean = true;
  isVisibleDetailTable: boolean = false;
  isVisibleDataTable: boolean = true;
  public sortedData: Array<any>;
  public notes: Array<any>;
  public group_notes: Array<any>;
  public notesGroup;
  public sortNotesGroup;
  public c_user;
  chargesPopup: any;
  public c_date = moment(new Date());
  public creationDateFilter: Boolean = true;
  public serviceDateFilter: Boolean = true;
  displayedColumns: string[] = ['checkbox', 'date_of_creation', 'patient_name', 'facility_title', 'dos', 'dob', 'updatedAt', 'provider_name', 'census_name', 'progress_status', 'bill_status', 'face_sheet', 'audit', 'biller_note', 'operation'];
  chargeStatus: string = 'default';
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('myCheckbox') checkbox!: MatCheckbox;
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  provideModel: any = '';
  facilityModel: any = "";
  company_id: any;
  // filter: any = {
  //   creation_date: {
  //     startDate: moment().subtract(7, 'days').toDate(),
  //     endDate: moment().toDate()
  //   },
  //   date_of_service: null

  // };
  filter: any = {
    creation_date: null,
    date_of_service: {
      startDate: moment().subtract(2, 'days'),
      endDate: moment()
    },
    dateFilter: 'dos',
    cpt_id: null,
    downloadReport : false,
    reportType: '',
    sendEmail: true,
    billStatus: '',
  };
  dateFilter: String = "dos";
  appliedFilter: IFilter;
  users: Array<any> = [];
  providers: Array<any> = [];
  note_types: Array<any> = [];
  facilities: Array<any> = [];
  patients: Array<any> = [];
  uniqueProviders: any = [];
  chargesArray: any = [];
  showPatientsSearch: boolean = false;
  searchText: string = "";
  status = [
    { title: 'Unsigned' },
    { title: 'Signed' },
    { title: 'Uploaded' }
  ];
  filteredProviders: Observable<string[]>;


  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };

  currentDate = new Date();
  notesToShow = null;
  currentRouteUrl: any;
  charges: any = [];
  provider: any;
  facility: any;
  groupedDates: string[];
  groupedData: any = [];
  groupedCharges: any = [];
  dataSource: any = new MatTableDataSource([])
  totalRecords: number = 0;
  fitlerButtonClicked: boolean = false;
  currentUser: any;
  showPccLogo: boolean = false;
  showMatrixLogo: boolean = false;
  showDnLogo: boolean = false;
  selectedCharges: any = [];
  cpts: any = [];
  cptCodesDropdownSettings: any = {};
  cptFilter: any;
  tabIndex: any = 0;
  p = 'patient';
  f = 'facesheet';
  companyName: any;
  loading: boolean;
  auditPopup: any;
  Separatecharges: any;
  company: any;
  selectedCptCodes: any[] = [];
  selectedCompanySubscription: any;
  isAdminSide: boolean = false;
  constructor(
    private _transcriptionCreateService: TranscriptionCreateService,
    public _authService: AuthService,
    private toastr: ToastrService,
    private _router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private billerDashboardService: BillerDashboardService,
    private dialog: MatDialog,
    private companyService: CompanyService,
    public userTypesRelationshipService: UserTypesRelationshipService,
    private dashboardService: DashboardService,
    private _faceSheetService: FaceSheetService,
    private fileExplorerService: FileExplorerService,
    private patientDocumentService: PatientDocumentService,
    private service: PatientRoundingSheetService

  ) {
    this.currentUser = this._authService.currentUser;
    if (this.currentUser.user_type != global.USER_TYPE.BILLER) {
      this.displayedColumns.splice(0, 1);
    }
    this.cptCodesDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'codeDescription', 
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: false
    };
  }

  ngOnInit(): void {
    if (window.location.pathname.includes('company')) {
      console.log('this.route.parent.parent.snapshot.params.id', this.route.parent.parent.snapshot.params.id);
      this.isAdminSide = true;
      this.company_id = this.route.parent.parent.snapshot.params.id;
    }
    else if (window.location.pathname.includes('manage-companies')) {
      this.company_id = this.route.parent.parent.snapshot.params.id;
    }
    else if (this.currentUser.user_type === global.USER_TYPE.BILLER) {
      this.selectedCompanySubscription = this.commonService.castSelectedCompany.subscribe((res : any)=> {
        if(res) {
          this.company_id = res;
          this.getProviderList();
          this.initCpts();
          this.initFacilities();
          this.initCharges();
        }else {
          this.company_id = this.currentUser.company_id;
        }
      });
      this.chargeStatus = 'submit';
      this.filter.status = 'submit';
    }
    
    if (this.commonService.getLocalStorageItem("admin-charge-capture")) {
      const { dateRange } = this.commonService.getLocalStorageItem("admin-charge-capture");
      this.filter.date_of_service = {
        startDate: moment(dateRange.startDate),
        endDate: moment(dateRange.endDate)
      };
    }
    const isProvider = JSON.parse(localStorage.getItem('admin-charge-capture:provider_id_name'));
    if (isProvider) {
      this.provideModel = isProvider.name;
      this.provider = isProvider.name;
      this.filter.provider_id = isProvider.id;
    }

    const isFacility = JSON.parse(localStorage.getItem('admin-charge-capture:facility_id_title'));
    if (isFacility) {
      this.facilityModel = isFacility.title;
      this.filter.facility_id = isFacility.id;
    }

    const isStatus = JSON.parse(localStorage.getItem("admin-charge-capture:select_status"));
    if (isStatus) {
      this.filter.status = isStatus.status;
      this.chargeStatus = isStatus.value;
      if (this.filter.status === "submit") {
        this.onSelectBillStatus("");
      }
    }

    const isSelctedCode = JSON.parse(localStorage.getItem("admin-charge-capture:cpt_codes"));
    if (isSelctedCode) {
      this.selectedCptCodes = [isSelctedCode];
      this.cptFilter = isSelctedCode._id;
    } else {
      this.cptFilter = [];
    }

    this.getProviderList();
    this.initCpts();

    this.initFacilities();
    this.initCharges();
    this.filteredProviders = this.providerControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterProvider(value)));
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterFacilities(value)));
    if (this.currentUser.user_type != 1 || this.currentUser.user_type != global.USER_TYPE.DOCTOR || this.currentUser.user_type != global.USER_TYPE.SNF_WC_NURSE) {
      this.displayedColumns = this.displayedColumns.filter(column => column != 'biller_note');
    }
  }

  ngOnDestroy(): void {
    if (window.location.pathname.includes('patient-charge')) {
      return;
    }
    this.removeFiltersFromStorage();
    if(this.selectedCompanySubscription) {
      this.selectedCompanySubscription.unsubscribe();
    }
  }

  removeFiltersFromStorage() {
    localStorage.removeItem("admin-charge-capture:check_filter_date");
    localStorage.removeItem("admin-charge-capture:provider_id_name");
    localStorage.removeItem("admin-charge-capture:facility_id_title");
    localStorage.removeItem("admin-charge-capture:select_status");
    localStorage.removeItem("admin-charge-capture:cpt_codes");
  }

  clearProviderFilter() {
    this.providerControl.setValue('');
    this.provider = null;
    this.filter.provider_id = null;
    localStorage.removeItem("admin-charge-capture:provider_id_name");
  }
  clearFacilityFilter() {
    this.facilityControl.setValue('');
    this.facilityModel = '';
    this.filter.facility_id = null;
    this.showPccLogo = false;
    this.showMatrixLogo = false;
    this.showDnLogo = false;
    localStorage.removeItem("admin-charge-capture:provider_id_name");
  }
  getProvControlStatus() {
    if (this.providerControl?.value && (this.providerControl?.value != '')) return true; else return false;
  }
  getFacControlStatus() {
    if (this.facilityControl?.value && (this.facilityControl?.value != '')) return true; else return false;
  }
  private filterFacilities(value: string): string[] {
    if (value) {
      if (value.length == 1) {
        this.showPccLogo = false;
      }
      const filterValue = value.toLowerCase();
      return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) > -1);
    }
    else {
      return this.facilities;
    }
  }

  private filterProvider(value: string): string[] {
    if (value && this.providers.length > 0) {
      const filterValue = value.toLowerCase();
      let users = this.providers.filter(option => (option.middle_name && option.middle_name.toLowerCase().indexOf(filterValue) === 0) || option.last_name.toLowerCase().indexOf(filterValue) === 0 || option.first_name.toLowerCase().indexOf(filterValue) === 0);
      return this.sortFirstNameVise(users);
    }
    else {
      return this.sortFirstNameVise(this.providers);
    }
  }

  onTabClick(event) {
    this.tabIndex = event.index;
    if (this.currentUser.product_owner) {
      this.tabIndex--;
    }
    return;
  }

  async initSoloGroupCharge(group) {
    let charge_id = group?.chargeList?.chargeList || [];

    const provider = group?.chargeList?.user;
    const facility = group?.chargeList?.facility;
    const census = group?.chargeList?.census;

    this.billerDashboardService.getChargeGroupSeparate(charge_id).subscribe(async (response: any) => {
      if (response.status === 200) {
        this.Separatecharges = response.data;

        for await (const ele of this.Separatecharges) {
          if (ele?.facility_id_ref) {
            ele.facility_id_ref = facility;
          }
          if (ele?.owner_id) {
            ele.owner_id = provider;
          }
          if (ele?.rounding_sheet_id) {
            ele.rounding_sheet_id = census;
          }
        }

        this.showPatientsSearch = true;
        this.isVisibleDetailTable = true;
        this.isVisibleTable = false;
        this.dataSource.data = this.Separatecharges;
        this.chargesArray = this.Separatecharges;

      }
    });
    group === null ? this.isVisibleDataTable = true : this.isVisibleDataTable = false

  }

  async initCharges() {
    this.filter.company_id = this.company_id;
    this.filter.dateFilter = this.dateFilter;
    this.filter.cpt_id = this.cptFilter;

    if (!this.filter.date_of_service) {
      return;
    }
    this.getCompanyName();
    this.loading = true;
    this.filter.downloadReport = false;
    this.billerDashboardService.getChargesByFilters(this.filter).subscribe(async (response: any) => {
      this.loading = false;
      if (response.status === 200) {
        this.totalRecords = 0;
        this.charges = response.data;

        for (const item of this.charges) {
          if (Array.isArray(item.groupedData)) {

            for (const key in item) {
              for (const value of item[key]) {
                if (typeof value === "object" && value !== null) {
                  this.totalRecords += value?.chargeList?.count;
                }
              }
            }
          }
        }

        //this.charges = await this.populateFeildsinCharges(this.charges);
        this.charges = this.sortChargesByCreationDate(this.charges);
      }
    });
  }
  auditClicked(element) {
    let charge_id = element._id;
    this.auditPopup = this.dialog.open(AuditPopupComponent, { data: charge_id, width: '40%', maxHeight: "40%", autoFocus: false })
    this.auditPopup.afterClosed().subscribe(async result => {

    });
  }
  async populateFeildsinCharges(charges) {
    this.totalRecords = 0;

    for await (const charge of charges) {
      if (charge.groupedData?.length > 0 && Array.isArray(charge.groupedData)) {
        for await (const group of charge.groupedData) {
          if (group?.chargeList.chargeList?.length > 0) {
            const provider = group?.chargeList?.user;
            const facility = group?.chargeList?.facility;
            const census = group?.chargeList?.census;
            this.company = group?.chargeList?.company_id;

            this.totalRecords += group?.chargeList?.count;

            for await (const ele of group.chargeList.chargeList) {
              if (ele?.facility_id_ref) {
                ele.facility_id_ref = facility;
              }
              if (ele?.owner_id) {
                ele.owner_id = provider;
              }
              if (ele?.rounding_sheet_id) {
                ele.rounding_sheet_id = census;
              }
              if (ele?.company_id) {
                ele.company_id = this.company;
              }
            }
          }
        }
      }
    }
    return charges;
  }

  sortChargesByCreationDate(charges) {
    var byDate = charges.slice(0);
    //console.log("byDate:",byDate);
    byDate.sort(function (a, b) {
      // return Date.parse(a.sort_date) < Date.parse(b.sort_date) ? 1 : Date.parse(a.sort_date) > Date.parse(b.sort_date) ? -1 : 0;
      return Date.parse(a._id) < Date.parse(b._id) ? 1 : Date.parse(a._id) > Date.parse(b._id) ? -1 : 0;

      //      return a._id < b._id ? 1 : a._id > b._id ? -1 : 0;
    });
    return byDate;
  }
  getProviderList() {
    this.userTypesRelationshipService.getDoctorsList('true', this.company_id).subscribe((response: any) => {
      if (response.status === 200) {
        this.providers = response.data;
        if (this.providers.length > 0) {
          //this.providers.sort(this.sortProviders);
          this.providers = this.sortFirstNameVise(this.providers);
          this.filteredProviders = this.providerControl.valueChanges.pipe(
            startWith(''),
            map((value: any) => this.filterProvider(value))
          );
          // this.providerControl.setValue(this.providers[0].full_name);
          // this.filter.provider = this.providers[0];
        }
      }
    });
  }

  async initCpts() {
    try {
      const filter = {
        company_id: this.company_id
      }
      const projection = {
        _id:1,
        company_id:1,
        cpt_ids:1
      }
      const populate = {
        cpt_ids:"code description"
      }
        const response: any = await lastValueFrom (this.companyService.getCompanyCPTRelations(filter, projection, populate));
        if (response.status === 200) {
          if(response.data && Array.isArray(response.data) && response.data.length > 0){
            this.cpts = response.data[0].cpt_ids;
          }
        }
    } catch (error) {
        console.error('Error:', error);
    }
}

  async onCodeSingleSelect($event) {
    this.cptFilter = $event._id;
    let cpt_selected_code = {
      _id: $event._id,
      code: $event.code
    };
    localStorage.setItem('admin-charge-capture:cpt_codes', JSON.stringify(cpt_selected_code));

  }

  onSelectBillStatus(billStatus) {
    if (billStatus && this.filter.status === "submit") {
      this.filter.billStatus = billStatus;
    }
    else {
      this.filter.billStatus = "";
    }
  }

  async onCodeSingleDeSelect($event) {
    this.cptFilter = null;
    localStorage.removeItem("admin-charge-capture:cpt_codes");

    console.log("this.cptFilter deSelect single : ", this.cptFilter);
  }

  async onCodeSelect($event) {
    this.cptFilter.push($event._id);
    console.log("this.cptFilter Select : ", this.cptFilter);

  }

  async onCodeDeSelect($event) {
    let index = this.cptFilter.indexOf($event._id);

    if (index >= 0) {
      this.cptFilter.splice(index, 1);
    }
    console.log("this.cptFilter deSelect : ", index, this.cptFilter);
  }




  sortProviders(a, b) {
    if (a.first_name < b.last_name) {
      return -1;
    }
    if (a.first_name > b.last_name) {
      return 1;
    }
    return 0;
  }
  async initFacilities(provider = null, source = null, company_id = null) {
    let response: any = {};
    if (provider) {
      response = await this._transcriptionCreateService.getFacilities(provider._id, source, company_id).toPromise();
    }
    if (response.status === 200) {
      this.facilities = response.data.array;
      this.filteredFacilities = this.facilityControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.filterFacilities(value))
      );
    }
  }
  async reSelectFacility() {
    let response: any = {};

    response = await this._transcriptionCreateService.getFacilities(this.filter.provider_id, null, this.company_id).toPromise();

    if (response.status === 200) {
      this.facilities = response.data.array;
      this.filteredFacilities = this.facilityControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.filterFacilities(value))
      );
    }
  }
  sortFirstNameVise(arrayTosort) {
    let users = arrayTosort;
    let result = users.sort(function (a, b) {
      if (a.first_name?.toLowerCase() < b.first_name?.toLowerCase()) { return -1; }
      if (a.first_name?.toLowerCase() > b.first_name?.toLowerCase()) { return 1; }
      return 0;
    })
    return result;
  }
  changeServiceDate(event) {
    if (event.startDate && event.endDate) {
      this.filter.date_of_service = {
        startDate: null,
        endDate: null
      }
      this.filter.date_of_service.startDate = event.startDate;
      this.filter.date_of_service.endDate = event.endDate;
      // this.filter.date_of_service.startDate = event.startDate.toDate();
      // this.filter.date_of_service.endDate = event.endDate.toDate();
      let startDate = moment(event.startDate);
      let endDate = moment(event.endDate);
      let noOfDays = endDate.diff(startDate, 'days');
      if (noOfDays > 30) {
        this.serviceDateFilter = false;
        this.filter.date_of_service.endDate = moment(this.filter.date_of_service?.startDate).add(29, "days").startOf('day');
        endDate = this.filter.date_of_service.endDate;
        this.toastr.error('Can not select more than 30 days', 'ERROR');

        setTimeout(() => {
          this.serviceDateFilter = true;
        }, 300)
      }
      const dateRange = {
        startDate: this.commonService.convertDateToStringforMoment(this.filter.date_of_service.startDate),
        endDate: this.commonService.convertDateToStringforMoment(this.filter.date_of_service.endDate)
      };
      this.commonService.setLocalStorageItem("admin-charge-capture", "dateRange", dateRange);
    }
  }

  onSelectProvider(item = null) {
    console.log("item", item);
    if (item) {
      this.initFacilities(item, null, this.company_id);
      this.provider = item;
      this.provideModel = item.full_name;
      this.filter.provider_id = item._id;
      const setProvider = {
        id: item._id,
        name: item.full_name
      }
      localStorage.setItem('admin-charge-capture:provider_id_name', JSON.stringify(setProvider));
    } else {
      this.provider = null;
      this.filter.provider_id = null;
      if ((this._authService.currentUser.user_type == 6 || this._authService.currentUser.user_type == global.USER_TYPE.BILLER)) {
        console.log("biller have cleared provider");
        if (this.filter.date_of_service.startDate && this.filter.date_of_service.endDate) {

          let startDate = moment(this.filter.date_of_service.startDate);
          let endDate = moment(this.filter.date_of_service.endDate);
          let noOfDays = endDate.diff(startDate, 'days');

          if (noOfDays > 30) {
            this.serviceDateFilter = false;
            this.filter.date_of_service.endDate = moment();
            this.filter.date_of_service.startDate = moment(this.filter.date_of_service?.endDate).subtract(7, "days").startOf('day');
            this.toastr.error('Can not select more than 30 days', 'ERROR');

            setTimeout(() => {
              this.serviceDateFilter = true;
            }, 300)
          }

        }

      }
    }
    // if ($event.isUserInput) {
    //   console.log("provider", provider);
    //   this.initFacilities(provider);
    //   this.filter.provider_id = provider._idonSelectProvider;
    //   this.providerControl.setValue(provider.full_name);
    // }
  }
  onSelectFacility(item = null) {
    if (item) {
      this.facility = item;
      this.filter.facility_id = item._id;
      const setFacility = {
        id: item._id,
        title: item.title
      }
      localStorage.setItem('admin-charge-capture:facility_id_title', JSON.stringify(setFacility));
      if (item.pcc_facId || item.source === 'PointClickCare') {
        this.showPccLogo = true;
      } else {
        this.showPccLogo = false;
      }
      if (item.source === 'MatrixCare') {
        this.showMatrixLogo = true;
      } else {
        this.showMatrixLogo = false;
      }
      if (item.source != 'PointClickCare' && item.source != 'MatrixCare' && !item.pcc_facId) {
        this.showDnLogo = true;
      } else {
        this.showDnLogo = false;
      }
    } else {
      if (this.currentUser.user_type === global.USER_TYPE.BILLER) {
        this.facilityModel = 'All';
        this.filter.facility_id = null;
      } else {
        this.facilityModel = '';
        this.filter.facility_id = null;
      }
    }
  }
  onSelectStatus(item = null) {
    if (this.dateFilter == 'dosub' && this.chargeStatus != 'submit') {
      this.dateFilter = 'dos';
    }
    if (item == 'submit' || item == 'draft' || item == 'billed') {
      this.filter.status = item;
      item === "submit" && this.onSelectBillStatus("");
      const setStatus = {
        status: this.filter.status,
        value: this.chargeStatus
      }
      item === "submit" && setStatus.value === "submit" && this.onSelectBillStatus("");
      localStorage.setItem('admin-charge-capture:select_status', JSON.stringify(setStatus));
      if (this.currentUser.user_type == global.USER_TYPE.BILLER) {
        if (item == 'submit') {
          this.displayedColumns.splice(0, 0, 'checkbox');
        } else {
          let findIndex = this.displayedColumns.findIndex((c) => c === 'checkbox')
          if (findIndex > -1) {
            this.displayedColumns.splice(findIndex, 1);
          }
        }
      }
    }
    else {
      this.chargeStatus = 'default';
      delete this.filter?.status;
      localStorage.removeItem("admin-charge-capture:select_status");
      if (this.currentUser.user_type == global.USER_TYPE.BILLER) {
        let findIndex = this.displayedColumns.findIndex((c) => c === 'checkbox')
        if (findIndex > -1) {
          this.displayedColumns.splice(findIndex, 1);
        }
      }
    }
    if (this.filter.status !== "submit") {
      delete this.filter.billStatus;
    }
  }
  changeCreationDate(event) {
    var startDate = moment(event.startDate);
    var endDate = moment(event.endDate);
    var noOfDays = endDate.diff(startDate, 'days');
    if (noOfDays > 30) {
      this.creationDateFilter = false;
      this.filter.creation_date.endDate = moment(this.filter.creation_date.startDate).add(29, "days").startOf('day').toDate();
      endDate = this.filter.creation_date.endDate;
      this.toastr.error('Can not select more than 30 days', 'ERROR');

      setTimeout(() => {
        this.creationDateFilter = true;
      }, 300)
    }
  }
  getDate(date) {
    return moment(new Date(date)).format('MMM DD, YYYY');
  }
  totalCount(groupedData) {
    if (Array.isArray(groupedData)) {
      let totalCount = 0;
      for (let i = 0; i < groupedData.length; i++) {
        totalCount += groupedData[i]?.chargeList?.count;
      }
      return totalCount;
    }
  }
  applyFilter() {
    const text = this.searchText.toLowerCase();
    this.dataSource.data = this.chargesArray.filter(data => data.patient_id.first_name.toLowerCase().includes(text) || data.patient_id.last_name.toLowerCase().includes(text));
  }
  handleApplyFilterClick() {
    // this.isVisibleDetailTable = false;
    // this.isVisibleTable = true;
    this.fitlerButtonClicked = true;
    this.initCharges();
  }
  resetFilter() {
    if (this._authService.currentUser.user_type == 6 || this._authService.currentUser.user_type == global.USER_TYPE.BILLER) {
      this.chargeStatus = 'submit';
    }
    else {
      this.chargeStatus = 'default';
    }
    this.showPccLogo = false;
    this.showMatrixLogo = false;
    this.showDnLogo = false;
    this.fitlerButtonClicked = false;
    this.provider = null;
    this.facility = null;
    this.selectedCptCodes = null;
    this.cptFilter = [];
    this.isVisibleDetailTable = false;
    this.isVisibleTable = true;
    delete this.filter?.creation_date;
    delete this.filter?.provider_id;
    delete this.filter?.facility_id;
    delete this.filter?.status;
    this.filter.date_of_service = {
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    };
    this.providerControl.setValue("");
    this.facilityControl.setValue("");
    this.initCharges();
    this.removeFiltersFromStorage()
    let changeDate = {
      startDate: this.filter.date_of_service.startDate,
      endDate: this.filter.date_of_service.endDate
    }
    localStorage.setItem('admin-charge-capture:check_filter_date', JSON.stringify(changeDate));
  }
  showChargeDetail(charges) {
    this.showPatientsSearch = true;
    this.isVisibleDetailTable = true;
    this.isVisibleTable = false;
    this.dataSource.data = charges;
    this.chargesArray = charges;
    this.filter.downloadReport = false;
  }
  //page, doctor: any = null, companyId = null, filter = {}, charge_id = null
  openDialog(element) {
    console.log(element);
    this.billerDashboardService.getPatientsChargesAdmin(null, null, this.company_id, {}, element._id).subscribe((response: any) => {
      if (response.status == 200) {
        if (Array.isArray(response.data) && response.data.length === 1) {
          let patient = response.data[0];
          this.chargesPopup = this.dialog.open(ChargesPopupComponent, { data: { patient, arrayOfcharges: this.chargesArray, route: this.route, adminSide: true }, width: '80%' });
          // this.chargesPopup.afterClosed().subscribe(() => {
          //   this.initCharges();
          //   this.isVisibleDetailTable = false;
          //   this.isVisibleTable = true;
          // });
        }
      }
    });
  }

  async onDeleteClick(element, index) {
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: "Are you sure you want to delete this Charge?"
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === "true") {
        const infoToast = this.toastr.info('Deleting Charge...', 'Please wait');
        let response: any = {};
        response = await this._transcriptionCreateService.deleteDraftedCharge(element._id, element.note_id).toPromise();
        if (response.status === 200) {
          this.dataSource.data = [];
          this.chargesArray.splice(index, 1);
          this.dataSource.data = this.chargesArray;
          this.dataSource.sort = this.sort;

          this.toastr.success("Charge deleted", "success");
          this.initCharges();
        } else {
          this.toastr.error(response.message, 'Failed');
        }
      }
    });
  }
  getVisitDate(element) {
    if (element.date_obj) {
      let { year, month, day, hour, minute } = element.date_obj;
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      let str = `${month}/${day}/${year}`;
      return str
    }
    else {
      let timeZone = 'America/New_York'
      if (element.facility_id_ref.pcc_timeZone) {
        timeZone = element.facility_id_ref.pcc_timeZone
      }
      else if (element.facility_id_ref.timeZone) {
        timeZone = element.facility_id_ref.timeZone
      }
      return moment(new Date(element.visit_date).toLocaleString('en-US', { timeZone: timeZone })).format('MM/DD/YYYY')
    }
    // return moment(new Date(date).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })).format('MMM DD, YYYY h:mm a');
  }//facilityTimeZone
  getdate(date, data = null) { 
    let d;
    if(data && data.facilityTimeZone){ 
      d = moment(new Date(date).toLocaleString('en-US', { timeZone: data.facilityTimeZone.timeZone })).format('MMM DD, YYYY');  
    }
    else{
      d = moment(new Date(date).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })).format('MMM DD, YYYY');
    }
    return d
    
  }
  getdateOnly(date) {
    return moment(new Date(date)).format('MMM DD, YYYY');
  }
  getDateOfUpdation(element) {
    // 'MMM d, y, h:mm a'
    let timeZone = 'America/New_York'
    if (element.facility_id_ref.pcc_timeZone) {
      timeZone = element.facility_id_ref.pcc_timeZone
    }
    else if (element.facility_id_ref.timeZone) {
      timeZone = element.facility_id_ref.timeZone
    }
    if (element.updatedAt) {
      return moment(new Date(element.updatedAt).toLocaleString('en-US', { timeZone: timeZone })).format('MMM DD, YYYY')
    }
    else return '-'
  }
  getDateOfCreation(element) {
    let timeZone = 'America/New_York'
    if (element.facility_id_ref.pcc_timeZone) {
      timeZone = element.facility_id_ref.pcc_timeZone
    }
    else if (element.facility_id_ref.timeZone) {
      timeZone = element.facility_id_ref.timeZone
    }
    if (element.createdAt) {
      return moment(new Date(element.createdAt).toLocaleString('en-US', { timeZone: timeZone })).format('MMM DD, YYYY')
    }
    else {
      return '-'
    }
    // return moment(new Date(element?.createdAt)).format('MMM DD, YYYY');
    if ((element.date_obj || element.date_obj_str) && (this.filter.dateFilter == "doc" || this.filter.dateFilter == "dos")) {
      let datee = element.date_obj_str ? element.date_obj_str : element.date_obj.year.toString() + '-' + element.date_obj.month.toString() + '-' + element.date_obj.day.toString();
      return moment(new Date(datee)).format('MMM DD, YYYY');
    } else {
      return moment(new Date(element?.createdAt)).format('MMM DD, YYYY');
    }
  }

  async editCharge(charge) {
    let response: any = await this.billerDashboardService.getPatientsChargesAdmin(null, null, this.company_id, {}, charge._id).toPromise()
    if (response.status == 200) {
      if (Array.isArray(response.data) && response.data.length === 1) {
        let patientCharge = response.data[0];
        console.log("Edit Charge Clicked: ", patientCharge)
        let date_obj;
        if (patientCharge.date_obj) {
          let { year, month, day, hour, minute } = patientCharge.date_obj;
          if (month < 10) {
            month = '0' + month;
          }
          if (day < 10) {
            day = '0' + day;
          }
          let str = `${month}-${day}-${year}`;
          if (hour && minute) {
            if (minute < 10) {
              minute = `0${minute}`
            }
            if (hour < 10) {
              hour = `0${hour}`
            }
            str += ` ${hour}:${minute}`
          }
          date_obj = str;
        }
        this.commonService.setDraftedCharge(patientCharge);
        let route = '';
        if(this.isAdminSide) {
          route = `/company/${this.company_id}/dashboard/patient-charge`
        }
        else {
          route = '/biller-charges/patient-charge';
        }
        this._router.navigate([route], {
          queryParams: {
            patient_id: patientCharge.patient_id._id,
            rs_id: patientCharge.rounding_sheet_id._id,
            visit_date: patientCharge.visit_date.toString(),
            patient_name: patientCharge.patient_id.first_name + ' ' + patientCharge.patient_id.last_name,
            dob: patientCharge.patient_id.date_of_birth,
            // facility_id: patient.facility_id
            facility_id: patientCharge.facility_id_ref._id,
            charge_id: patientCharge._id,
            date_obj,
            backCtrl: true,
          }
        });
      }
    }
  }

  downloadReportNew() {
    let allNotesData = [];
    let dateName = ('(' + moment(new Date(this.filter.date_of_service?.startDate)).format('MMM Do')) + ' - ' + (moment(new Date(this.filter.date_of_service?.endDate)).format('MMM Do') + ')');
    let fileName = (this.companyName || 'All Charges Report') + ' ' + (dateName || '');
    this.charges.forEach((charges) => {
      charges.groupedData.forEach((gData) => {
        allNotesData.push({
          "provider": gData?.chargeList?.user?.first_name + " " + gData?.chargeList?.user?.last_name,
          "dos": this.getdateOnly(charges._id),
          "facility": gData?.chargeList?.facility?.title,
          "census": gData?.chargeList?.census?.name,
          "status": gData?.chargeList?._id?.status === 'submit' ? 'submitted' : gData?.chargeList?._id?.status,
          "bill_status": gData?.chargeList?._id?.bill_status,
          "total": gData?.chargeList?.count
        });
      });
    });
    let groups = allNotesData.reduce((groups, item) => ({
      ...groups,
      [item.provider]: [...(groups[item.provider] || []), item]
    }), {});
    for(let provider in groups) {
      let tempArr = groups[provider];
      groups[provider] = tempArr.reduce((groups, item) => ({
        ...groups,
        [item.dos]: [...(groups[item.dos] || []), item]
      }), {});

    }
    allNotesData = groups;
    this.toastr.info("Generating Report","Please wait...");
    this.billerDashboardService.exportGroupedReportAsXLSX(allNotesData, true).subscribe((response: any) => {
      if (response instanceof HttpResponse) {
        var url = window.URL.createObjectURL(response.body);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = `Grouped Charges Report V2`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        this.toastr.success("Report Downloaded", "Success");
      }
    });
  }
  async downloadReport(type = "grouped", reportType) {
    let allNotesData = [];
    let dateName = ('(' + moment(new Date(this.filter.date_of_service?.startDate)).format('MMM Do')) + ' - ' + (moment(new Date(this.filter.date_of_service?.endDate)).format('MMM Do') + ')');
    let fileName = (this.companyName || 'All Charges Report') + ' ' + (dateName || '');
    console.log("dateName : ", fileName,  this.charges);
    if (type === "grouped") {
      this.charges.forEach((charges) => {
        charges.groupedData.forEach((gData) => {
          allNotesData.push({
            "provider": gData?.chargeList?.user?.first_name + " " + gData?.chargeList?.user?.last_name,
            "dos": this.getdateOnly(charges._id),
            "facility": gData?.chargeList?.facility?.title,
            "census": gData?.chargeList?.census?.name,
            "status": gData?.chargeList?._id?.status === 'submit' ? 'submitted' : gData?.chargeList?._id?.status,
            "bill_status": gData?.chargeList?._id?.bill_status,
            "total": gData?.chargeList?.count
          });
        });
      });

      if (this.filter.dateFilter == "doc") {
        this.toastr.info("Generating Report","Please wait...");
        this.billerDashboardService.exportGroupedReportAsXLSX_DOC(allNotesData).subscribe((response: any) => {
          if (response instanceof HttpResponse) {
            var url = window.URL.createObjectURL(response.body);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = `Grouped Charges Report`;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
            this.toastr.success("Report Downloaded", "Success");
          }
        });
      } else if (this.filter.dateFilter == "dou") {
        this.toastr.info("Generating Report","Please wait...");
        this.billerDashboardService.exportGroupedReportAsXLSX_DOU(allNotesData).subscribe((response: any) => {
          if (response instanceof HttpResponse) {
            var url = window.URL.createObjectURL(response.body);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = `Grouped Charges Report`;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
            this.toastr.success("Report Downloaded", "Success");
          }
        });
      } else {
        this.toastr.info("Generating Report","Please wait...");
        this.billerDashboardService.exportGroupedReportAsXLSX(allNotesData).subscribe((response: any) => {
          if (response instanceof HttpResponse) {
            var url = window.URL.createObjectURL(response.body);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = `Grouped Charges Report`;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
            this.toastr.success("Report Downloaded", "Success");
          }
        });
      }


    } else {
      this.filter.reportType = reportType;
      await this.initFullReport();
    }
  }

  async initFullReport() {
    this.filter.downloadReport = true;
    const response = await lastValueFrom(this.billerDashboardService.getChargesByFilters(this.filter));
    if (response['status'] === 204) {
      this.toastr.info(response['message'], "Please Wait");
    }
    else {
      this.toastr.error(response['message'], "Failed");
    }
  }

  async generateFullReport() {
    let allNotesData = [];
    let dateName = ('(' + moment(new Date(this.filter.date_of_service?.startDate)).format('MMM Do')) + ' - ' + (moment(new Date(this.filter.date_of_service?.endDate)).format('MMM Do') + ')');
    let fileName = (this.companyName || 'All Charges Report') + ' ' + (dateName || '');
    this.filter.downloadReport = true;
    this.billerDashboardService.getChargesByFilters(this.filter).subscribe(async (response: any) => {

      if (response.status === 200) {
        let ResCharges = await this.populateFeildsinCharges(response.data);
        ResCharges = this.sortChargesByCreationDate(ResCharges);
        this.toastr.info("Generating Report","please wait ...");
        ResCharges.forEach((charges) => {
          charges.groupedData.forEach((gData) => {
            gData?.chargeList?.chargeList.forEach((cData) => {
              let icd_codes = "";
              let cpt_codes = "";
              let cpt_POS = "";
              let cpt_modifiers = "";
              let cpt_units = "";
              let source = "";

              cData?.icd_id.forEach((icd, index) => {
                if (index == 0) {
                  icd_codes += icd?.code;
                }
                else {
                  icd_codes += ", " + icd?.code;
                }
              });
              cData?.cpt_id.forEach((cpt, index) => {
                if (index == 0) {
                  cpt_codes += cpt?.code;
                  if (cpt?.place_of_service)
                    cpt_POS += (cpt?.place_of_service || '');
                }
                else {
                  cpt_codes += ", " + cpt?.code;
                  if (cpt?.place_of_service)
                    cpt_POS += ", " + (cpt?.place_of_service || '');
                }
              });
              cData?.cpt_modifiers.forEach((cptModifier, index) => {
                if (cptModifier?.modifier) {
                  if (index == 0) {
                    cpt_modifiers += cptModifier?.modifier;
                  }
                  else {
                    cpt_modifiers += ", " + cptModifier?.modifier;
                  }
                }
              });
              cData?.cpt_modifiers.forEach((cptModifier, index) => {
                if (cptModifier?.unit) {
                  if (index == 0) {
                    cpt_units += cptModifier?.unit;
                  }
                  else {
                    cpt_units += ", " + cptModifier?.unit;
                  }
                }
              });
              if (cData && cData.facility_id_ref) {
                if (cData.facility_id_ref.source) {
                  source = cData.facility_id_ref.source
                } else {
                  source = 'DN'
                }
              }
              let date_obj = cData.date_obj?.year?.toString() + '-' + cData?.date_obj?.month.toString() + '-' + cData?.date_obj?.day.toString();
              allNotesData.push({
                "created_at": this.getdate(cData?.createdAt, cData),
                "submit_date": cData.status == 'submit'? this.getdate(cData.submit_date, cData) : '',
                "provider_id": cData?.owner_id._id,
                "provider": cData?.owner_id?.first_name + " " + cData?.owner_id?.last_name,
                // "dos":   this.commonService.dateObjToString_format2(cData.date_obj, false),  //this.getdateOnly(date_obj), // 
                "dos": this.getDOS(cData.date_obj),  //this.getdateOnly(date_obj), // 
                "facility_id": cData?.facility_id_ref?._id,
                "facility": cData?.facility_id_ref?.title,
                "facility_npi": cData?.facility_id_ref?.npi,
                "census": cData?.rounding_sheet_id?.name,
                "status": cData?.status === 'submit' ? 'submitted' : cData?.status,
                "bill_status": cData.bill_status,
                "patient_fname": cData?.patient_id?.first_name,
                "patient_lname": cData?.patient_id?.last_name,
                "patient_id": cData?.patient_id?._id,
                "patient": cData?.patient_id?.first_name + " " + cData?.patient_id?.last_name,
                // "date_of_birth": cData?.patient_id?.date_of_birth,
                "date_of_birth": this.getDOB(cData?.patient_id?.date_of_birth),
                "updated_at": this.getdate(cData?.updatedAt, cData),
                "icd": icd_codes,
                "cpt": cpt_codes,
                "charge_id": cData?._id,
                "external_provider_id": cData?.owner_id?.trueRCMID,
                // "external_facility_id": cData?.facility_id_ref?.trueRCMID,
                "pos": cpt_POS,
                "Snpi": cData?.Snpi,
                "Pnpi": cData?.Pnpi,
                "modifier": cData?.company_id?.modifier,
                "cpt_modifier": cpt_modifiers,
                "cpt_unit": cpt_units,
                "source": source,
                "ssn": cData?.patient_id?.pcc_payload?.ssn,
                "medicare_number": cData?.patient_id?.pcc_payload?.medicareBeneficiaryIdentifier,
                "medicaid_number": cData?.patient_id?.pcc_payload?.medicaidNumber,
                "patient_address": cData?.patient_id?.address,
                "city": cData?.patient_id?.city,
                "state": cData?.patient_id?.state,
                "zip_code": cData?.patient_id?.zip_code,
                "pcp_name": this.getPCPName(cData?.patient_id),
                "admission_date": cData?.patient_id?.pcc_payload?.admissionDate,
                "primary_insurance": (cData?.patient_id?.source == "PointClickCare") ? (this.formatInsuranceName(cData?.patient_id?.pcc_coverage_data, 'Primary')) : ((cData?.insurance?.p_insurance_carrier && cData?.insurance?.p_insurance_carrier != undefined && cData?.insurance?.p_insurance_carrier != null) ? cData?.insurance?.p_insurance_carrier : " ") + " " + ((cData?.insurance?.p_insurance_holder_name && cData?.insurance?.p_insurance_holder_name != undefined && cData?.insurance?.p_insurance_holder_name != null) ? cData?.insurance?.p_insurance_holder_name : " "),
                "secondary_insurance": (cData?.patient_id?.source == "PointClickCare") ? (this.formatInsuranceName(cData?.patient_id?.pcc_coverage_data, 'Secondary')) : ((cData?.insurance?.s_insurance_carrier && cData?.insurance?.s_insurance_carrier != undefined && cData?.insurance?.s_insurance_carrier != null) ? cData?.insurance?.s_insurance_carrier : " ") + " " + ((cData?.insurance?.s_insurance_holder_name && cData?.insurance?.s_insurance_holder_name != undefined && cData?.insurance?.s_insurance_holder_name != null) ? cData?.insurance?.s_insurance_holder_name : " "),
                "primary_insurance_policy_number": (cData?.patient_id?.source == "PointClickCare") ? (this.formatPolicyNumber(cData?.patient_id?.pcc_coverage_data, 'Primary')) : ((cData?.insurance?.p_insurancePolicyNumber && cData?.insurance?.p_insurancePolicyNumber != undefined && cData?.insurance?.p_insurancePolicyNumber != null) ? cData?.insurance?.p_insurancePolicyNumber : " "),
                "secondary_insurance_policy_number": (cData?.patient_id?.source == "PointClickCare") ? (this.formatPolicyNumber(cData?.patient_id?.pcc_coverage_data, 'Secondary')) : ((cData?.insurance?.s_insurancePolicyNumber && cData?.insurance?.s_insurancePolicyNumber != undefined && cData?.insurance?.s_insurancePolicyNumber != null) ? cData?.insurance?.s_insurancePolicyNumber : " "),
                "patient_gender": cData?.patient_id?.gender,
                "primary_physician": ((cData?.patient?.primary_practitioner_first_name && cData?.patient?.primary_practitioner_first_name != undefined && cData?.patient?.primary_practitioner_first_name != null) ? cData?.patient?.primary_practitioner_first_name : " ") + " " + ((cData?.patient?.primary_practitioner_last_name && cData?.patient?.primary_practitioner_last_name != undefined && cData?.patient?.primary_practitioner_last_name != null) ? cData?.patient?.primary_practitioner_last_name : " ")
              });
            })
          });
        });
        await this.convertToXLSX(allNotesData, dateName, fileName);
        // this.billerDashboardService.exportFullReportAsXLSX(allNotesData, this.company).subscribe((response: any) => {
        //   if (response instanceof HttpResponse) {
        //     var url = window.URL.createObjectURL(response.body);
        //     var a = document.createElement('a');
        //     document.body.appendChild(a);
        //     a.setAttribute('style', 'display: none');
        //     a.href = url;
        //     a.download = 'Charge Capture - ' + (fileName || 'All Charges Report');
        //     a.click();
        //     window.URL.revokeObjectURL(url);
        //     a.remove(); // remove the element
        //     this.toastr.success("Report Downloaded", "Success");
        //   }
        // });
        // console.log(allNotesData);

      }
    });
  }
  getPCPName(patient) {
    let first_name = '';
    let last_name = '';
    if (patient) {
      if (patient.pcc_primaryPractitioner?.firstName && patient.pcc_primaryPractitioner?.firstName != undefined && patient.pcc_primaryPractitioner?.firstName != null)
        first_name = patient.pcc_primaryPractitioner.firstName
      if (patient.pcc_primaryPractitioner?.lastName && patient.pcc_primaryPractitioner?.lastName != undefined && patient.pcc_primaryPractitioner?.lastName != null)
        last_name = patient.pcc_primaryPractitioner.lastName
    }
    return first_name + " " + last_name;
  }

  formatInsuranceName(coverage_data, payerRank) {
    if (!coverage_data) {
      return 'N/A';
    }
    if (coverage_data?.payers) {
      if (Array.isArray(coverage_data?.payers)) {
        const primaryPayor = coverage_data.payers.find(payer => payer.payerRank === payerRank);
        if (primaryPayor) {
          return primaryPayor.payerName;
        }
      } else {
        return '';
      }
    }
    else {
      const payer = coverage_data[payerRank];
      if (payer) {
        return payer.payerName;
      }
      return 'N/A';
    }
  }

  formatPolicyNumber(coverage_data, payerRank) {
    if (!coverage_data) {
      return 'N/A';
    }
    const payer = coverage_data[payerRank];
    if (payer?.issuer?.planNumber) {
      return payer.issuer.planNumber;
    }
    return 'N/A';
  }

  getDOB(dob) {
    if (dob) {
      let datesplit = dob.split('-');
      let year = datesplit[0];
      let month = datesplit[1];
      let day = datesplit[2];
      let formatted_date_of_birth;
      let alphaMonth = this.months[Number(month - 1)];
      datesplit = `${alphaMonth} ${day}, ${year}`
      formatted_date_of_birth = datesplit;
      return formatted_date_of_birth;
    }
  }

  getDOS(date_obj) {
    if (date_obj) {
      let datesplitDos = '';
      let { year, month, day, hour = 0, minute = 0 } = date_obj;
      let formatted_date_of_service;
      let alphaMonth = this.months[Number(month - 1)];
      datesplitDos = `${alphaMonth}-${day}-${year}`
      formatted_date_of_service = datesplitDos;
      return formatted_date_of_service;
    }
  }
  async getCompanyName() {
    const companyName = await this.companyService.getCompanyName(this.filter.company_id).toPromise()
    this.companyName = companyName.data?.name;
    console.log("this.companyData : ", this.companyName);
  }

  checkVoidCensus(patientRoundingSheet) {
    if (patientRoundingSheet) {
      if (patientRoundingSheet?.is_void) {
        if (patientRoundingSheet.is_void === true) return false;
        else return true;
      } else {
        return true
      }
    } else {
      return true;
    }
  }
  generateFacesheetAndDownloadAsPDF(patient_id) {
    console.log('patient id', patient_id);
    const infoToastr: any = this.toastr.info('Generating PDF', 'Please wait...');
    try {
      const params = {
        patient_id
      }
      return this.dashboardService.downloadFile(global.url + API_URL.PATIENT.generateFacesheetAndDownloadAsPDF, params).subscribe((res: any) => {
        if (res instanceof HttpResponse) {

          var url = window.URL.createObjectURL(res.body);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = 'facesheet.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
          this.toastr.clear(infoToastr.toastId);
        } else {
          if (res.type === 0) {
          } else if (res.type === 3) {
            const { loaded, total } = res;
            const progress = Math.round(loaded / total * 100);
            if (progress > 0) {
            }
          }
        }
        if (res.status == 200) {
          return true;
        }
      })
    } catch (error) {
      const { message = 'Something went wrong, please try again' } = error;
      this.toastr.error(message);
    } finally {
      this.toastr.clear(infoToastr.toastId);
      this.toastr.success("Downloaded successFully")
    }
  }
  
  viewPDF(element, index?) {
    if (element.faceSheet?.aws_path && element.faceSheet.aws_path.includes("http")) {
      this.dialog.open(PdfViewerPopComponent, {
        width: '50vw',
        height: '95vh',
        data: { file_path: element.faceSheet.aws_path, file: element }
      })
    } else if (!element.faceSheet) {
      this.dialog.open(PdfViewerPopComponent, {
        width: '50vw',
        height: '95vh',
        data: {
          file: element
        }
      });
    } 
    else { 
      let data = {
        patient_id: element.patient_id._id,
        aws_path: element.faceSheet?.aws_path,
        title: element.faceSheet?.title
      }
      this.patientDocumentService.generateViewPdfUrl(data).subscribe((response: any) => {
        if (response.status === 200) {
          if (!element.faceSheet) {
            let faceSheet = {
              aws_path: null,
              title: null
            }
            element = {
              ...element, faceSheet
            }
          }
          element.faceSheet.aws_path = response.document.aws_path
          element.faceSheet.title = response.document.title
          this.toastr.clear();
          this.dialog.open(PdfViewerPopComponent, {
            width: '50vw',
            height: '95vh',
            data: {
              file_path: element.faceSheet.aws_path,
              ...(element.company_facility_patients &&
                element.company_facility_patients.facility_id &&
                element.company_facility_patients.facility_id.source &&
                { file: element })
            }
          });
        }
        else {
          this.toastr.error('Something went wrong please try again.')
        }
      }, () => this.toastr.error('Something went wrong please try again.')
      )
    }
  }
  isPCCFacility(source) {
    return source?.toLowerCase() === 'pointclickcare';
  }
  isMatrixFacility(source) {
    return source?.toLowerCase() === 'matrixcare';
  }
  isDNFacility(source) {
    return source?.toLowerCase() != 'pointclickcare' && source?.toLowerCase() != 'matrixcare';
  }
  isPCCFacilityDetails(facility) {
    let source = facility.facility_id_ref.source;
    return source?.toLowerCase() === 'pointclickcare';
  }
  isMatrixFacilityDetails(facility) {
    let source = facility.facility_id_ref.source;
    return source?.toLowerCase() === 'matrixcare';
  }
  isDNFacilityDetails(facility) {
    let source = facility.facility_id_ref.source;
    return source?.toLowerCase() != 'pointclickcare' && source?.toLowerCase() != 'matrixcare';
  }
  viewBillerNote(note) {
    swal({
      title: "Biller Comment",
      text: note,
      dangerMode: true,
      buttons: [, 'Close'],
    })
      .then(() => {
      });
  }

  async downloadFileWithPresignedURL(element, index) {
    console.log("patient_id : ", element);
    if (element.patient_id?.pcc_patientId && element.patient_id?.pcc_coverage_data) {
      const infoToast = this.toastr.info('Preparing file to download...', 'Please wait', { disableTimeOut: true });
      if (this.generateFacesheetAndDownloadAsPDF(element.patient_id._id)) {
        this.toastr.clear(infoToast.toastId);
      } else {
        this.showPatientDocumentsUploadDialog(index, element.patient_id._id);
      }
    } else {
      if (!element.faceSheet) {
        this.showPatientDocumentsUploadDialog(index, element.patient_id._id)
      } else {
        const infoToast = this.toastr.info('Preparing file to download...', 'Please wait', { disableTimeOut: true });
        try {
          const downloadFileResponse: any = await this.fileExplorerService.downLoadAnyFileWithURL(element.faceSheet.aws_path, element.faceSheet.title, element.patient_id?._id).toPromise();
          var url = window.URL.createObjectURL(downloadFileResponse);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = <string>element.faceSheet.title;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        } catch (error) {
          this.toastr.error('Unable to download file.', 'Failed');
        } finally {
          this.toastr.clear(infoToast.toastId);
          this.toastr.success("Downloaded SuccessFully")
        }
      }
    }
  }

  async downloadFile(awsPath, title) {
    const infoToast = this.toastr.info('Preparing file to download...', 'Please wait', { disableTimeOut: true });
    try {
      const downloadFileResponse: any = await this.fileExplorerService.downLoadAnyFile(awsPath, title).toPromise();
      var url = window.URL.createObjectURL(downloadFileResponse);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = <string>title;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      this.toastr.error('Unable to download file.', 'Failed');
    } finally {
      this.toastr.clear(infoToast.toastId);
      this.toastr.success("Downloaded SuccessFully")
    }
  }
  showPatientDocumentsUploadDialog(index, patientId) {
    console.log("this.chargesArray", this.chargesArray);
    const dialogRef = this.dialog.open(
      PatientDocumentsUploadDialog,
      { width: '80%' }
    );
    dialogRef.beforeClosed().subscribe(async (fileInput: any) => {
      if (fileInput) {
        const [file] = fileInput.files;
        const infoToast = this.toastr.info('Uploading Face Sheet...', 'Please wait')
        const company_id = this._authService.currentUser.company_id;
        this._faceSheetService.uploadFaceSheet(file, patientId, company_id).subscribe((response: any) => {
          if (response.status === 200) {
            const { _id, title, aws_path } = response.data;
            const faceSheet = {
              _id,
              title,
              aws_path
            };
            this.chargesArray[index].faceSheet = faceSheet;
            this.dataSource.data[index].faceSheet = faceSheet;
            this.toastr.success("Face Sheet Uploaded", 'Success');
          }
          else {
            console.error(response.data.status, response.data.message);
            this.toastr.error(response.data.message, 'Failed');
          }
        });
      }
    });
  }
  async downloadBatchReport() {
    this.toastr.info('Downloading Batch Notes Report', 'Downloading...');
    let chargeIds = [];
    this.charges.forEach((charges) => {
      const report = {} as BReport;
      report.dos = this.getDate(charges._id);
      report.provider = [];
      charges.groupedData.forEach((gData) => {
        for(let id of gData.chargeList?.chargeList)
          chargeIds.push({chargeId:id, dos: report.dos})
      });
    });
    try {
      const response = await lastValueFrom(this.billerDashboardService.generateBatchReportofFacesheets(chargeIds));
      if (response["status"] === 200) {
        this.toastr.success(response["message"], 'Success');
      } else {
        this.toastr.error(response["message"], "Error");
      }
    } catch (err) {
      this.toastr.error('Something went wrong while downloading the batch report', 'Failed');
    }
  }

  sortData(sort: Sort) {
    const data = this.chargesArray.slice();
    this.chargesArray = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {

        case 'patient_name':

          return compare(a.patient_id?.first_name, b.patient_id?.first_name, isAsc);

        default: return 0;
      }
    });
    // this.dataSource = this.selectedpatients;
    this.dataSource = new MatTableDataSource(this.chargesArray);
    this.dataSource.sort = this.sort;

  }


  selectedCharge(element) {
    if (this.selectedCharges.findIndex(charge => charge == element._id) > -1) {
      return true
    }
    else {
      return false
    }
  }
  selectCharge(element, event) {
    if (event.checked) {
      this.selectedCharges.push(element._id)
    }
    if (!event.checked) {
      let index = this.selectedCharges.indexOf(element._id);
      if (index > -1) {
        this.selectedCharges.splice(index, 1)
      }
    }
  }
  selectChargeAll($event) {
    if ($event.checked) {
      let allCharges = this.dataSource.data;
      this.selectedCharges = allCharges.map(charg => charg._id);
    }
    if (!$event.checked) {
      this.selectedCharges = [];
    }
  }
  async billedAllCharges(billStatus) {
    let response: any = await this.billerDashboardService.SubmitAllandApprove(this.selectedCharges, 'submit', billStatus).toPromise();
    if (response.status == 200) {
      for(let charge of this.dataSource.data) {
        charge.bill_status = billStatus;
      }
      this.selectedCharges = [];
      this.toastr.success("All Selected Charges are billed", "Success");
      this.checkbox.checked = false;
      this.initCharges();
      // this.isVisibleDetailTable = false;
    } else {
      this.toastr.error("Something went Wrong", "Error");
    }
  }
  async archivedAllCharges() {
    let response: any = await this.billerDashboardService.SubmitAllandApprove(this.selectedCharges, 'archive').toPromise();
    if (response.status == 200) {
      this.selectedCharges = [];
      this.toastr.success("All Selected Charges are archived", "Success");
      this.initCharges();
      this.isVisibleDetailTable = false;
    } else {
      this.toastr.error("Something went Wrong", "Error");
    }
  }

  generateFacesheetForMatrixAndDownloadAsPDF(patient_id) {
    const infoToastr: any = this.toastr.info('Generating PDF', 'Please wait...');
    try {
      const params = {
        source: 'MatrixCare',
        patient_id
      }
      return this.dashboardService.downloadFile(global.url + API_URL.PATIENT.generateFacesheetForMatrixAndDownloadAsPDF, params).subscribe((res: any) => {
        if (res instanceof HttpResponse) {

          var url = window.URL.createObjectURL(res.body);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = 'facesheet.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
          this.toastr.clear(infoToastr.toastId);
        } else {
          if (res.type === 0) {
          } else if (res.type === 3) {
            const { loaded, total } = res;
            const progress = Math.round(loaded / total * 100);
            if (progress > 0) {
            }
          }
        }
        if (res.status == 200) {
          return true;
        }
      })
    } catch (error) {
      const { message = 'Something went wrong, please try again' } = error;
      this.toastr.error(message);
    } finally {
      this.toastr.clear(infoToastr.toastId);
      this.toastr.success("Downloaded successFully")
    }
  }

  uploadFaceSheetActive(element, index) {
    return true;
  }
  downloadFaceSheetActive(element, index) {
    const charge = element;
    const patient = charge.patient_id;
    if (!patient) return false;

    if (patient.source === 'PointClickCare') return true;
    if (patient.source === 'MatrixCare' && patient.matrix_payload?.coverages?.length > 0) return true;
    if (charge.faceSheet) return true;

    return false;
  }
  async handleUploadFacesheetClick(element, index) {
    const charge = element;
    const patient = charge.patient_id;
    this.showPatientDocumentsUploadDialog(index, patient._id)
  }

  async handleDownloadFacesheetClick(element, index) {
    const charge = element;
    const patient = charge.patient_id;
    if(element?.faceSheet?.aws_path){
      let aws_path = element.faceSheet.aws_path;
      let title = element.faceSheet.title;
      let patient_id = element.patient_id?._id;
      this._faceSheetService.downloadUploadedFile(aws_path, title, patient_id);
    }
    else{
      const details = {
        ...this._authService.authObject,
        patientId: patient._id,
      }
      this._faceSheetService.generateFacesheetAndDownloadAsPDF({}, details)
    }
  }

  downloadJSONReport() {
      this.billerDashboardService.downloadJSONFile(this.filter).subscribe((data) => {
      if (data['status']) {
        const jsonData = JSON.stringify(data['submitCharges']);
        const file = new Blob([jsonData], { type: 'text/json' });
        this.download(file, 'submit-charges.json');
      }
      else {
        this.toastr.error('No Data Found', 'ERROR')
      }
    })
  }

  download(blob, filename) {
    var a = document.createElement("a"),
    url = URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
  openChargeCommentDialog(charge, index) {
    const config = {
      data: _.cloneDeep(charge),
      width: '50%'
    }
    this.dialog.open(ChargeCommentDialogComponent, config).afterClosed().subscribe((updatedCharge) => {
      if (updatedCharge) {
        charge.note = updatedCharge.note;
        this.chargesArray[index].note = updatedCharge.note;
      }
    });
  }
  patient_id: any;
  showPatient: boolean = false;
  onPatientClick(patient) {
    if(this.currentUser.user_type == '1') {
      this._router.navigate([`/company/${this.currentUser.company_id}/patient-detail/${patient.patient_id._id}`]);
    }
    else if(this.currentUser.user_type == '6'){
      this.showPatient = true;
      this.patient_id = patient.patient_id._id;
      // this._router.navigate([`/biller-charges/patient-detail/${patient.patient_id._id}`])
    }
  }
  closePatient(event) {
    this.showPatient = false;
  }

  async convertToXLSX(chargesData, dateName, fileName) {
    if (chargesData.length > 0) {
      const infoToastr = this.toastr.info('Fetching Data...', "Please Wait");
      const reportTitle = 'Charge Capture - ' + (fileName || 'All Charges Report') 
      const columnsData = [
        { header: "DOS", key: "dos", width: 22 },
        { header: "DOB", key: "date_of_birth", width: 22 },
        { header: "Patient ID", key: "patient_id", width: 25 },
        { header: "Patient First Name", key: "patient_fname", width: 20 },
        { header: "Patient Last Name", key: "patient_lname", width: 20 },
        { header: "Patient Name", key: "patient", width: 20 },
        { header: "Provider ID", key: "provider_id", width: 25 },
        { header: "Provider", key: "provider", width: 20 },
        { header: "External Provider ID", key: "external_provider_id", width: 25 },
        { header: "Facility ID", key: "facility_id", width: 25 },
        { header: "Facility", key: "facility", width: 30 },
        { header: "Facility NPI", key: "facility_npi", width: 20 }, 
        { header: "Census", key: "census", width: 15 },
        { header: "Charge Status", key: "status", width: 20 },
        { header: "Billed Status", key: "bill_status", width: 20 },
        { header: "Submit Date", key: "submit_date", width: 20 },
        { header: "Date of Creation", key: "created_at", width: 20 },
        { header: "Update Date", key: "updated_at", width: 20 },
        { header: "Provider NPI", key: "Pnpi", width: 20 },
        { header: "Supervisor NPI", key: "Snpi", width: 20 },
        { header: "Modifier", key: "modifier", width: 20 },
        { header: "Charge ID", key: "charge_id", width: 25 },
        { header: "POS", key: "pos", width: 20 },
        { header: "CPT Codes", key: "cpt", width: 20 },
        { header: "ICD Codes", key: "icd", width: 20 },
        { header: "CPT Modifiers", key: "cpt_modifier", width: 20 },
        { header: "CPT Units", key: "cpt_unit", width: 20 },
        { header: "Source", key: "source", width: 20 },
        { header: "SSN", key: "ssn", width: 20 },
        { header: "Medicare Number", key: "medicare_number", width: 20 },
        { header: "Medicaid Number", key: "medicaid_number", width: 20 },
        { header: "Patient Address", key: "patient_address", width: 40 },
        { header: "City", key: "city", width: 20 },
        { header: "State", key: "state", width: 20 },
        { header: "Zip Code", key: "zip_code", width: 20 },
        { header: "PCP", key: "pcp_name", width: 20 },
        { header: "Admission Date", key: "admission_date", width: 20 },
        { header: "Primary Insurance", key: "primary_insurance", width: 30 },
        { header: "Secondary Insurance", key: "secondary_insurance", width: 30 },
        { header: "Primary Insurance - Policy Number", key: "primary_insurance_policy_number", width: 20 },
        { header: "Secondary Insurance - Policy Number", key: "secondary_insurance_policy_number", width: 20 },
        { header: "Gender", key: "patient_gender", width: 20 },
        { header: "Primary Physician/Attending Physician", key: "primary_physician", width: 20 },
      ]
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(`${reportTitle}`);
      worksheet.columns = columnsData;
      for (const charge of chargesData) {
        worksheet.addRow(flatten(charge));
      }
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
      });
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.alignment = { wrapText: true };
        })
      })
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${reportTitle}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.toastr.success("Report Downloaded", "Success");
      this.toastr.clear(infoToastr.toastId);
    }
    else {
      this.toastr.info('No Data To Export!', "Info");
    }
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}